import {combineReducers} from 'redux'

const identity = <TState = {}>(state: TState) => state || null
const rootReducer = combineReducers({
  config: identity,
  i18n: identity,
})

export default rootReducer
